import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConcluirCadastroComponent } from './concluir-cadastro.component';

const routes: Routes = [
  {
    path: 'concluir-cadastro/:contaId',
    component: ConcluirCadastroComponent,
    data: { title: 'Setup' }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class ConcluirCadastroRoutingModule { }
